export default __webpack_public_path__ + "static/national-metric-mobile-a61c4f2947d98823483c36e5fbe6498a.svg";